import { useState } from 'react';
import DateTimePicker from 'react-datetime-picker';
import moment from 'moment-timezone';
import { Calendar } from 'lucide-react';
import { Label } from '../../ui/label';
import { Switch } from '../../ui/switch';
import { Separator } from '../../ui/separator';

const RenderBestTimeOffer = ({
  currentClientTimeZone,
  currentClientBestTimes,
  onChange
}) => {
  const [isCustomTime, setIsCustomTime] = useState(false);
  const [date, setDate] = useState(() => {
    const initialDate = getTime(currentClientTimeZone);
    return initialDate instanceof Date && !isNaN(initialDate)
      ? initialDate
      : new Date();
  });

  const handleCustomTime = () => {
    setIsCustomTime(!isCustomTime);
    if (!isCustomTime) {
      setDate(getTime(currentClientTimeZone));
    }
  };

  const handleDateChange = (newDate) => {
    if (newDate instanceof Date && !isNaN(newDate)) {
      setDate(newDate);
      if (onChange) {
        onChange(newDate);
      }
    }
  };

  return (
    <div className="space-y-4">
      <Separator />

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Calendar className="h-5 w-5 text-primary" />
          <Label className="text-base font-medium">
            {isCustomTime ? 'Schedule Post' : 'Best Time'}
          </Label>
        </div>
        <Switch checked={isCustomTime} onCheckedChange={handleCustomTime} />
      </div>

      {isCustomTime && (
        <div className="pl-8 space-y-4">
          <p className="text-sm text-muted-foreground">
            Please select date and time
          </p>
          <DateTimePicker
            onChange={handleDateChange}
            disableClock
            value={date instanceof Date && !isNaN(date) ? date : new Date()}
            minDate={getTime(currentClientTimeZone)}
            name="postSchedule"
            required
            format="dd/MM/yyyy hh:mm a"
            clearIcon={null}
            calendarIcon={null}
          />
        </div>
      )}
    </div>
  );
};

const getTime = (currentClientTimeZone) => {
  const timeZonesMap = {
    'Eastern Daylight Time - (GMT-4)': 'America/New_York',
    'Central Daylight Time - (GMT-5)': 'America/Chicago',
    'Mountain Daylight Time - (GMT-6)': 'America/Denver',
    'Mountain Standard Time - (GMT-7)': 'America/Phoenix',
    'Pacific Daylight Time - (GMT-7)': 'America/Los_Angeles',
    'Alaska Daylight Time - (GMT-8)': 'America/Anchorage'
  };

  const validTimeZone =
    timeZonesMap[currentClientTimeZone] || 'Pacific/Honolulu';
  return moment().tz(validTimeZone).toDate();
};

export default RenderBestTimeOffer;
